import { API_PATH_INTERNAL, COMMON_DATA_ERROR_MESSAGE } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { CommonData } from '@/types/responses/common-data'

class CommonDataService {
  async getAll(): Promise<CommonData> {
    const { data } = await apiService.get<CommonData>(
      `${API_PATH_INTERNAL}/common-data/all`,
    )

    // The common data endpoint sometimes returns empty results in the dev
    // environment because of some caching issue. Since the app assumes the
    // common data is always available in order to work properly, let's throw
    // an error to avoid subtle/misleading issues. We'll display an error
    // message in the UI when this happens.
    if (!data.companyTypes || data.companyTypes.length === 0) {
      throw new Error(COMMON_DATA_ERROR_MESSAGE)
    }

    return {
      serviceAreas: data.serviceAreas,
      fcaServiceAreas: data.fcaServiceAreas,
      fcaServiceTypes: data.fcaServiceTypes,
      expertiseAreas: data.expertiseAreas,
      referralStatuses: data.referralStatuses,
      regulators: data.regulators,
      companyTypes: data.companyTypes,
      networks: data.networks,
      referralSources: data.referralSources,
    }
  }
}

const commonDataService = new CommonDataService()

export default commonDataService
